import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	more: {
		id: 'navigation-apps-sidebar-nav4-common.common.more-nav-menu-item.more',
		defaultMessage: 'More',
		description: 'Message for more nav menu item in the sidebar',
	},
});
